import {Component, computed, Input, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {IonCol, IonDatetime, IonDatetimeButton, IonModal, IonRow} from '@ionic/angular/standalone';
import {TranslatePipe} from '@ngx-translate/core';
import moment from 'moment';
import {LanguageService} from '../../../../services/language/language.service';

@Component({
    selector: 'app-date-range-picker',
    templateUrl: './date-range-picker.component.html',
    styleUrls: ['./date-range-picker.component.css'],
    imports: [IonCol, IonRow, IonDatetime, IonModal, IonDatetimeButton, ReactiveFormsModule, TranslatePipe],
    standalone: true,
})
export class DateRangePickerComponent implements OnInit {
    @Input({required: true}) maxPeriodDifference!: number;
    @Input({required: true}) form!: FormGroup;
    @Input({required: true}) startControlName!: string;
    @Input({required: true}) endControlName!: string;
    @Input() formGroupName: string | null = null;

    public endDateMin!: string;
    public endDateMax!: string;
    public startDateMax!: string;

    /** BCP 47 locale string for the active language, used by ion-datetime. */
    public readonly ionLocale = computed(() => this.languageService.currentBcp47());

    constructor(public languageService: LanguageService) {}

    ngOnInit(): void {
        const formValues = this.form.getRawValue();

        this.endDateMin = formValues.timePeriod.startDate;
        this.endDateMax = formValues.timePeriod.startDate;
        this.startDateMax = new Date().toISOString();
        this.updateEndDateFilterLimits(formValues.timePeriod.startDate);

        this.form.get(`${this.formGroupName}.${this.startControlName}`)?.valueChanges.subscribe((startDate) => {
            const utcValue = this.convertToUTC(startDate);
            this.form.get(`${this.formGroupName}.${this.startControlName}`)?.setValue(utcValue, {emitEvent: false});
            this.updateEndDateFilterLimits(utcValue);
        });

        this.form.get(`${this.formGroupName}.${this.endControlName}`)?.valueChanges.subscribe((endDate) => {
            this.form.get(`${this.formGroupName}.${this.endControlName}`)?.setValue(this.convertToUTC(endDate), {emitEvent: false});
        });
    }

    private updateEndDateBounds(startDate: string) {
        const newStartDate = new Date(startDate);
        let newMaxEndDate = new Date(newStartDate);

        newMaxEndDate.setDate(newMaxEndDate.getDate() + this.maxPeriodDifference);
        const today = new Date();
        newMaxEndDate = newMaxEndDate < today ? newMaxEndDate : today;

        this.endDateMin = startDate;
        this.endDateMax = newMaxEndDate.toISOString();
    }

    private updateEndDateValue() {
        const startDate = new Date(this.endDateMin);
        const maxDate = new Date(this.endDateMax);
        const currentEndDate = new Date(this.form.get(`${this.formGroupName}.${this.endControlName}`)?.value ?? new Date());

        let newEndDate = currentEndDate;
        if (currentEndDate > maxDate) {
            newEndDate = maxDate;
        } else if (currentEndDate < startDate) {
            newEndDate = startDate;
        }

        this.form.patchValue({
            timePeriod: {
                endDate: newEndDate.toISOString(),
            }
        });
    }

    private updateEndDateFilterLimits(startDate: string) {
        this.updateEndDateBounds(startDate);
        setTimeout(() => this.updateEndDateValue(), 0);
    }

    private convertToUTC(dateString: string): string {
        return moment.utc(dateString).toISOString();
    }
}
